import React from "react";
import { Link } from "react-router-dom";
import useHRCopy from "../i18n/useHRCopy";
import OnHumanHRLogo from "../../components/logos/OnHumanHRLogo";
import Label from "./Label";
import { useBrandTransition } from "../../components/BrandTransitionProvider";
import { CONTACT_EMAIL } from "../contact";

export default function HRFooter() {
  const copy = useHRCopy();
  const { startTechTransition } = useBrandTransition();

  const backToTop = () => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  };

  const navLinks = [
    { to: "/anamenu", label: copy.nav.home },
    { to: "/hakkimda", label: copy.nav.about },
    { to: "/hizmetlerim", label: copy.nav.services },
    { to: "/calismailkelerim", label: copy.footer.principles },
    { to: "/iletisim", label: copy.nav.contact },
  ];

  return (
    <footer className="bg-paper border-t border-line">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <OnHumanHRLogo className="h-9 w-auto" />
            <p className="mt-4 text-[14.5px] text-steel leading-relaxed max-w-sm">{copy.footer.desc}</p>
          </div>
          <nav className="md:col-span-4 grid grid-cols-2 gap-3 content-start font-hanken font-medium text-[15px]">
            {navLinks.map((l) => (
              <Link key={l.to} to={l.to} className="text-steel hover:text-ink transition-colors duration-300">
                {l.label}
              </Link>
            ))}
            <Link
              to="/onhumantech"
              onClick={(e) => { e.preventDefault(); startTechTransition(); }}
              className="text-steel hover:text-ink transition-colors duration-300"
            >
              {copy.footer.tech} ↗
            </Link>
          </nav>
          <div className="md:col-span-3">
            <Label>{copy.footer.contact}</Label>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="block mt-3 font-hanken font-semibold text-[15px] text-navy hover:text-royal transition-colors duration-300"
            >
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px] text-steel">
          <span>© {new Date().getFullYear()} {copy.brand.name}. {copy.footer.rights}</span>
          <span className="flex items-center gap-6">
            <span>Istanbul · Turkey</span>
            <button
              onClick={backToTop}
              className="font-semibold text-steel hover:text-ink transition-colors duration-300"
            >
              {copy.footer.backToTop} ↑
            </button>
          </span>
        </div>
      </div>
    </footer>
  );
}
